const Footer = () => {
    return ( 
        <div>Hello</div>
     );
}
 
export default Footer;